import { Switcher } from '@components/Switcher';
import { TextArea, TextInput } from '@gurupay/gp-ui-library';
import { useState } from 'react';
import type { ControllerRenderProps, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type PaymentDetailsSwitcherProps<T> = ControllerRenderProps<T> & {
	required?: boolean;
	error?: { message?: string };
	isDisabled?: boolean;
};

export const PaymentDetailsSwitcher = <T extends FieldValues>({
	required = false,
	error,
	isDisabled,
	...fieldsProps
}: PaymentDetailsSwitcherProps<T>) => {
	const [paymentDetailsType, setPaymentDetailsType] = useState('description');
	const { t } = useTranslation('', {
		keyPrefix: 'payments.newPayment.data.transferType',
	});
	const paymentDetails: { label: string; value: string }[] = [
		{
			label: t('description'),
			value: 'description',
		},
		{
			label: t('refNo'),
			value: 'referenceNumber',
		},
	];

	return (
		<div className="space-y-space-16 max-w-[500px]">
			<Switcher
				onChange={setPaymentDetailsType}
				options={paymentDetails}
				value={paymentDetailsType}
			/>
			<div>
				{paymentDetailsType === 'description' ? (
					<TextArea
						id="description"
						{...fieldsProps}
						error={error?.message}
						isDisabled={isDisabled}
						isRequired={required}
						label={t('description')}
					/>
				) : (
					<TextInput
						{...fieldsProps}
						error={error?.message}
						isDisabled={isDisabled}
						isRequired={required}
						label={t('refNo')}
					/>
				)}
			</div>
		</div>
	);
};
